import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import {GlobalStyle} from "./globalStyles";

ReactDOM.render(
  <Router>
    <GlobalStyle color="slate" fontFamily={0} />
    <App />
  </Router>,
  document.getElementById('root')
);
